import { getRequest, patchRequest, postRequest } from '../request/request.service';
import { OUTBOUND_API } from './outbound-calls.constants';
import {
  OutboundScenario,
  OutboundScenarioPayload,
  OutboundScenariosParams,
  OutboundScenariosResponse,
} from './scenarios.service.types';

const SCENARIOS_URL = `${OUTBOUND_API}/scenarios`;

export function getOutboundScenarios({ company_id, active }: OutboundScenariosParams) {
  return getRequest<OutboundScenariosResponse>(SCENARIOS_URL, {
    params: { company_id, active },
  });
}

export function createOutboundScenario(companyId: number, payload: OutboundScenarioPayload) {
  return postRequest<OutboundScenario>(SCENARIOS_URL, {
    params: { company_id: companyId },
    data: payload,
  });
}

export function updateOutboundScenario(id: number, payload: Partial<OutboundScenarioPayload>) {
  return patchRequest<OutboundScenario>(`${SCENARIOS_URL}/${id}`, { data: payload });
}
